module.exports = __webpack_public_path__ + "img/app_store_icon.06b25128.svg";